import React from 'react';

import './Button.scss';

interface ButtonProps {
    primary?: boolean;
    secondary?: boolean;
    tertiary?: boolean;
    accent?: boolean;
    size?: 'standard' | 'small';
    disabled?: boolean;
    handleClick?: () => void;
    children: JSX.Element;
    type?: 'submit' | 'button';
    setClass?: string;
}

function Button({primary, secondary, tertiary, accent, size = 'standard', disabled, handleClick, children, type, setClass}: ButtonProps){
    const themeClass = `${accent ? 'accent':''} ${primary?'primary':''} ${secondary?'secondary':''} ${tertiary ? 'tertiary' : ''} ${setClass ?  setClass : ''}`
    const sizeClass = size === 'small' ? 'size_small' : 'size_standard';

    return(
        <button className={`${themeClass} ${sizeClass} __Button`} onClick={handleClick} type={type || "button"} disabled={disabled}>
            {children}
        </button>
    )
}

export default Button;